import React from 'react';

function AbaTags({
  adicionarTag,
  novaTag,
  setNovaTag,
  tags,
  editandoId,
  textoEditado,
  setTextoEditado,
  salvarEdicao,
  iniciarEdicao,
  excluirTag,
  somenteConsulta = false,
}) {
  return (
    <div className="routine-panel">
      {somenteConsulta ? (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <p className="routine-callout__text">
            Perfil técnico em modo somente consulta. As tags podem ser analisadas, mas não podem ser alteradas.
          </p>
        </div>
      ) : (
        <form onSubmit={adicionarTag} className="routine-form-surface routine-surface">
          <div className="routine-field routine-field--grow">
            <label className="routine-label">Nova tag</label>
            <input
              type="text"
              placeholder="Ex: Cervejas"
              value={novaTag}
              onChange={(e) => setNovaTag(e.target.value)}
              className="routine-input"
            />
          </div>

          <div className="routine-actions">
            <button type="submit" className="routine-btn routine-btn--primary">
              Adicionar tag
            </button>
          </div>
        </form>
      )}

      <div className="routine-table-wrap">
        <table className="routine-table">
          <thead>
            <tr>
              <th>Tag cadastrada</th>
              <th style={{ width: '240px', textAlign: 'center' }}>{somenteConsulta ? 'Consulta' : 'Ações'}</th>
            </tr>
          </thead>
          <tbody>
            {tags.map((tag) => (
              <tr key={tag.id}>
                <td>
                  {!somenteConsulta && editandoId === tag.id ? (
                    <input
                      type="text"
                      value={textoEditado}
                      onChange={(e) => setTextoEditado(e.target.value)}
                      className="routine-input"
                    />
                  ) : (
                    <strong>{tag.nome_tag}</strong>
                  )}
                </td>
                <td>
                  {somenteConsulta ? (
                    <span className="routine-section-subtitle" style={{ margin: 0 }}>
                      Consulta liberada
                    </span>
                  ) : (
                    <div className="admin-actions-row">
                      {editandoId === tag.id ? (
                        <>
                          <button type="button" className="routine-btn routine-btn--primary" onClick={() => salvarEdicao(tag.id)}>
                            Salvar
                          </button>
                          <button type="button" className="routine-btn routine-btn--soft" onClick={() => setTextoEditado(tag.nome_tag)}>
                            Ajustar texto
                          </button>
                        </>
                      ) : (
                        <>
                          <button type="button" className="routine-btn routine-btn--soft" onClick={() => iniciarEdicao(tag)}>
                            Editar
                          </button>
                          <button type="button" className="routine-btn routine-btn--danger" onClick={() => excluirTag(tag.id)}>
                            Excluir
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            ))}

            {tags.length === 0 && (
              <tr>
                <td colSpan="2" className="routine-empty">
                  Nenhuma tag cadastrada no momento.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AbaTags;
